import Component from "../abstracts/Component";
import { isMobile, MobileBreakpoint } from "../utils/MobileUtils";
import YextFaqUtils from "../utils/YextFaqUtils";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";
import { trapFocusOnModal } from "../utils/TrapFocus";

export default class FaqComponent extends Component {
  get SELECTORS() {
    return {
      yextForm: "[data-yext-form]",
      yextInput: "[data-yext-input]",
      yextFaqContainer: "[data-yext-faq-autocomplete]",
      yextSingleFaq: "[data-yext-single-faq]",
      yextFaqCopyLink: "[data-copy-button]",
      closeSearchBtn: "[data-close-search]",
      performSearchBtn: "[data-search-go]",
      performSearchIcon: "[data-search-icon]",
      singleCard: "[data-single-card]",
      singleCardLink: "[data-single-card-link]",
      collapseTrigger: "[data-trigger]",
      menuContainer: "[data-sticky-header]",
      resultLabel: "[data-result-label]",
    };
  }

  get CLASSES() {
    return {
      active: "active",
      hidden: "--hidden",
      copied: "copied",
      showCopyLink: "show-copy-link",
      faqsContainer: "yext-faq-suggestions",
      singleFaq: "yext-faq-suggestions__singlefaq",
      singleFaqTitle: "yext-faq-suggestions__singlefaq__title",
      singleFaqCat: "yext-faq-suggestions__singlefaq__category",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.clickOutside = this.clickOutside.bind(this);
    this.focusTrapActive = false; 
    this.yextForm = this.$component.querySelector(this.SELECTORS.yextForm);
    this.yextInput = this.$component.querySelector(this.SELECTORS.yextInput);
    this.yextFaqContainer = this.$component.querySelector(
      this.SELECTORS.yextFaqContainer,
    );
    this.yextSingleFaq = this.$component.querySelectorAll(
      this.SELECTORS.yextSingleFaq,
    );
    this.yextFaqCopyLink = this.$component.querySelectorAll(
      this.SELECTORS.yextFaqCopyLink,
    );
    this.closeSearchBtn = this.$component.querySelector(
      this.SELECTORS.closeSearchBtn,
    );
    this.performSearchBtn = this.$component.querySelector(
      this.SELECTORS.performSearchBtn,
    );
    this.performSearchIcon = this.$component.querySelector(
      this.SELECTORS.performSearchIcon,
    );
    this.singleCard = this.$component.querySelectorAll(
      this.SELECTORS.singleCard,
    );
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
    
    const resultLabelElement = this.$component.querySelector(this.SELECTORS.resultLabel);
    this.resultLabel = resultLabelElement?.dataset?.resultLabel;
  }

  buildFaqs(event) {
    // faqs
    let faqs = event.payload.faqs.results;
    // check
    if (typeof faqs === "undefined") {
      console.log("no faq founded");
      return false;
    }
    // limit for first void search
    if (event.payload.input === "") {
      faqs = faqs.slice(0, 5);
    }

    // refresh screen reader message
    let message = this.resultLabel;
    if (message && message.includes("{0}")) {
      message = message.replace("{0}", faqs.length);
    }
    this.liveRegion.sayMessage(message);

    // vars
    let searchTerms = event.payload.input.split(" ");
    let singleFaqBasqUrl = this.yextForm.dataset;
    // outer div
    let faqDiv = document.createElement("div");
    faqDiv.classList.add(this.CLASSES.faqsContainer);
    faqDiv.role = "listbox";
    // cycle each results
    faqs.forEach((faq) => {
      //
      let catName = faq.data.c_linked_entity_FAQ[0].name;
      let catTitle = faq.data.c_linked_entity_FAQ[0].title;
      // single faq build
      let singleFaqDiv = document.createElement("a");
      singleFaqDiv.classList.add(this.CLASSES.singleFaq);
      singleFaqDiv.role = "option";
      singleFaqDiv.setAttribute("tabindex", "0");
      // title
      let singleFaqTitle = document.createElement("span");
      singleFaqTitle.classList.add(this.CLASSES.singleFaqTitle);
      singleFaqTitle.innerHTML = faq.data.question;
      // build title with highlighted words
      searchTerms.forEach((term) => {
        if (
          term !== "" &&
          faq.data.question.toLowerCase().includes(term.toLowerCase())
        ) {
          let highlightedTitle = faq.data.question.replace(
            new RegExp(term, "gi"),
            "<b>" + term + "</b>",
          );
          singleFaqTitle.innerHTML = highlightedTitle;
        }
      });
      singleFaqDiv.append(singleFaqTitle);
      let hastTitle = encodeURI(
        faq.data.question.replace(/\s/g, "-").toLowerCase(),
      );
      // cat
      let singleFaqCat = document.createElement("span");
      singleFaqCat.classList.add(this.CLASSES.singleFaqCat);
      singleFaqCat.innerHTML = catTitle.toUpperCase();
      singleFaqDiv.append(singleFaqCat);
      // url
      let singleFaqUrl =
        singleFaqBasqUrl.faqBaseUrl +
        "/" +
        catName +
        "#f-" +
        faq.data.id +
        "-" +
        hastTitle;
      singleFaqDiv.setAttribute("href", singleFaqUrl);
      singleFaqDiv.setAttribute("data-cat", catName);
      singleFaqDiv.setAttribute("data-faq-id", faq.data.id);
      // final append
      faqDiv.append(singleFaqDiv);
    });
    // append to input or rebuild
    let faqWindow = this.yextFaqContainer.querySelector(
      "." + this.CLASSES.faqsContainer,
    );

    if (faqWindow == null) {
      this.yextFaqContainer.append(faqDiv);
      faqWindow = faqDiv;
    } else {
      faqWindow.innerHTML = faqDiv.innerHTML;
    }

    if (this.focusTrapActive) {
      trapFocusOnModal(faqWindow);
    }

    // then bind click search TODO
    this.bindSearchOnFaq();
  }

  clickOutside(e) {
    // if I click outside the wrapper
    if (
      e.target !== this.yextFaqContainer &&
      e.target.closest("." + this.CLASSES.faqsContainer) === null
    ) {
      this.closeFaqsWindow();
    }
  }

  closeFaqsWindow() {
    this.focusTrapActive = false; // Deactivate focus trap
    let faqWindow = this.yextFaqContainer.querySelector(
      "." + this.CLASSES.faqsContainer,
    );
    if (faqWindow !== null) {
      faqWindow.remove();
    }
  }

  debounce(callback, wait) {
    let timeout;
    return (...args) => {
      this.toggleIcon();
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        callback.apply(this, args);
      }, wait);
    };
  }

  eventAutocomplete() {
    if (this.yextInput.value.length > 2) {
      // launch the autocomplete
      YextFaqUtils.getYextFaq(this.yextInput.value);
    }
    if (this.yextInput.value.length) {
      // void container ?
      let faqWindow = this.yextFaqContainer.querySelector(
        "." + this.CLASSES.faqsContainer,
      );
      if (faqWindow !== null) {
        faqWindow.innerHTML = "";
      }
    }
  }

  bindSearch() {
    let self = this;
    if (this.yextInput == null) return false;
    if (this.yextInput.value !== "") this.toggleIcon();
    // on input, start the countdown
    this.yextInput.addEventListener(
      "input",
      self.debounce(() => {
        self.eventAutocomplete();
      }, 500),
    );
    
    // Handle keyboard navigation from input to suggestions
    this.yextInput.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        let faqWindow = self.yextFaqContainer.querySelector(
          "." + self.CLASSES.faqsContainer,
        );
        if (faqWindow !== null) {
          // Activate focus trap when user navigates to suggestions
          self.focusTrapActive = true;
          trapFocusOnModal(faqWindow);
          // Focus first suggestion
          let firstSuggestion = faqWindow.querySelector("." + self.CLASSES.singleFaq);
          if (firstSuggestion) {
            firstSuggestion.focus();
          }
        }
      }
    });
  }

  bindSearchOnFaq() {
    let self = this;
    let faqWindow = this.yextFaqContainer.querySelector(
      "." + this.CLASSES.faqsContainer,
    );
    // check faq window opened
    if (faqWindow !== null) {
      let faqs = faqWindow.querySelectorAll("." + this.CLASSES.singleFaq);
      if (faqs !== null && faqs.length > 0) {
        // let's cycle all the faq
        faqs.forEach((singleFaq, index) => {
          // Activate focus trap when any suggestion receives focus
          singleFaq.addEventListener("focus", (e) => {
            if (!self.focusTrapActive) {
              self.focusTrapActive = true;
              trapFocusOnModal(faqWindow);
            }
          });
          
          // bind click
          singleFaq.addEventListener("click", (e) => {
            e.preventDefault();
            if (
              typeof singleFaq.href !== "undefined" &&
              singleFaq.href !== ""
            ) {
              location.replace(singleFaq.href);

              // check if I am in the same page
              if (window.location.pathname.includes(singleFaq.dataset.cat)) {
                self.closeFaqsWindow();
                let targetFaq = document.querySelector(
                  "[data-faq-id=" + singleFaq.dataset.faqId + "]",
                );
                setTimeout(function () {
                  self.faqOpen(targetFaq);
                }, 500);
              }
            }
          });
          
          // Handle keyboard navigation within suggestions
          singleFaq.addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown") {
              e.preventDefault();
              let nextSuggestion = faqs[index + 1];
              if (nextSuggestion) {
                nextSuggestion.focus();
              }
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              if (index === 0) {
                // Return to input and deactivate focus trap
                self.focusTrapActive = false;
                self.yextInput.focus();
              } else {
                let prevSuggestion = faqs[index - 1];
                if (prevSuggestion) {
                  prevSuggestion.focus();
                }
              }
            } else if (e.key === "Enter") {
              e.preventDefault();
              singleFaq.click();
            } else if (e.key === "Tab" && e.shiftKey && index === 0) {
              // Shift+Tab from first suggestion should go back to input and deactivate focus trap
              self.focusTrapActive = false;
              // Let the default tab behavior happen to return to input
            }
          });
        });
      }
    }
  }

  getHeaderHeight() {
    // selectors
    let menuContainer = document.querySelector(this.SELECTORS.menuContainer);
    // offset
    let menuContainerOffset =
      menuContainer && !isMobile(MobileBreakpoint.Max1023)
        ? menuContainer.offsetHeight
        : 0;
    return menuContainerOffset;
  }

  faqOpen(singleFaq) {
    let self = this;
    if (singleFaq === null) return false;
    let trigger = singleFaq.querySelector(this.SELECTORS.collapseTrigger);
    if (trigger !== null) {
      trigger.click();
    }
    setTimeout(function () {
      let scrollFromTop =
        window.pageYOffset +
        singleFaq.getBoundingClientRect().top -
        self.getHeaderHeight();
      window.scroll({
        behavior: "smooth",
        left: 0,
        top: scrollFromTop,
      });
    }, 500);
  }

  singleFaqOpen() {
    let self = this;
    // check hash
    let hash = location.hash.substr(1);
    if (
      hash !== "" &&
      this.yextSingleFaq !== null &&
      this.yextSingleFaq.length > 0
    ) {
      // let's cycle all the faq
      this.yextSingleFaq.forEach((singleFaq) => {
        if (hash.includes(singleFaq.dataset.faqId)) {
          // let's open the faq
          self.faqOpen(singleFaq);
        }
      });
    }
  }

  singleFaqLinkCopy() {
    let self = this;
    // loop the links
    if (this.yextFaqCopyLink !== null && this.yextFaqCopyLink.length > 0) {
      // let's cycle all the faq
      this.yextFaqCopyLink.forEach((copyLink) => {
        copyLink.addEventListener("click", (e) => {
          e.stopPropagation();
          let singleFaq = copyLink.closest(self.SELECTORS.yextSingleFaq);
          self.writeClipboardText(copyLink, singleFaq.dataset.faqUrl);
        });
        
        // Handle keydown event for Enter key
        copyLink.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            let singleFaq = copyLink.closest(self.SELECTORS.yextSingleFaq);
            self.writeClipboardText(copyLink, singleFaq.dataset.faqUrl);
          }
        });
      });
    }
  }

  toggleIcon() {
    if (this.yextInput.value !== "") {
      this.performSearchBtn.classList.remove(this.CLASSES.hidden);
      this.performSearchIcon.classList.remove(this.CLASSES.hidden);
      $(this.SELECTORS.performSearchIcon).addClass("active");
    } else {
      this.performSearchBtn.classList.add(this.CLASSES.hidden);
      this.performSearchIcon.classList.add(this.CLASSES.hidden);
      $(this.SELECTORS.performSearchIcon).removeClass("active");
    }
    this.closeSearchBtn.classList.add(this.CLASSES.hidden);
  }

  writeClipboardText(btn, text) {
    let self = this;
    try {
      navigator.clipboard.writeText(text).then(
        function () {
          btn.classList.add(self.CLASSES.copied);
          
          // Announce to screen readers that link has been copied
          const faqContainer = self.$component.querySelector('.yext-faq-list');
          if (self.liveRegion && faqContainer) {
            const message = faqContainer.dataset.msgCopied;
            if (message) {
              self.liveRegion.sayMessage(message);
            }
          }
          
          setTimeout(function () {
            btn.classList.remove(self.CLASSES.copied);
          }, 2000);
        },
        function () {
          /* clipboard write failed */
          console.log("NOT copied");
        },
      );
    } catch (error) {
      console.error(error.message);
    }
  }

  bindEvents() {
    let self = this;
    // click on the close icon
    this.closeSearchBtn.addEventListener("click", () => {
      this.yextInput.value = "";
      this.closeSearchBtn.classList.add(this.CLASSES.hidden);
      this.yextInput.focus();
    });
    // click on input
    this.yextInput.addEventListener("focus", (e) => {
      // Deactivate focus trap when returning to input
      self.focusTrapActive = false;
      // launch void suggestion
      YextFaqUtils.getYextFaq("");
    });
    // let's listen for faq to arrive
    this.$on(this.$customEvents.YEXT_EVENTS.faqsLoaded, (event) => {
      // go build faqs
      self.buildFaqs(event);
    });
    // click on dom
    document.addEventListener("click", this.clickOutside);

    this.yextFaqContainer.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        self.focusTrapActive = false; // Deactivate focus trap
        self.closeFaqsWindow();
        
        // Find the next focusable element after the input
        const focusableElements = document.querySelectorAll(
          'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
        );
        const focusableArray = Array.from(focusableElements);
        const inputIndex = focusableArray.indexOf(self.yextInput);
        const nextElement = focusableArray[inputIndex + 1];
        
        if (nextElement) {
          nextElement.focus();
        }
      }
    });

    // Assicurati che il container possa ricevere eventi da tastiera
    this.yextFaqContainer.setAttribute("tabindex", "-1");
  }

  bindFooterCardActive() {
    let currentUrl = window.location.origin + window.location.pathname;
    this.singleCard.forEach((singleCard) => {
      let link = singleCard.querySelector(this.SELECTORS.singleCardLink);
      if (link.href === currentUrl) {
        singleCard.classList.add(this.CLASSES.active);
      }
    });
  }

  bindCopyLinkVisibility() {
    let self = this;
    // Bind events to all FAQ triggers to toggle copy-link visibility
    if (this.yextSingleFaq && this.yextSingleFaq.length > 0) {
      this.yextSingleFaq.forEach((singleFaq) => {
        const trigger = singleFaq.querySelector(this.SELECTORS.collapseTrigger);
        const copyLink = singleFaq.querySelector(this.SELECTORS.yextFaqCopyLink);
        
        if (trigger && copyLink) {
          // Initial state check
          if (trigger.dataset.trigger === "on") {
            singleFaq.classList.add(self.CLASSES.showCopyLink);
          }
          
          // Create a MutationObserver to watch for changes in data-trigger attribute
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'data-trigger') {
                const currentValue = trigger.dataset.trigger;
                if (currentValue === "on") {
                  singleFaq.classList.add(self.CLASSES.showCopyLink);
                } else {
                  singleFaq.classList.remove(self.CLASSES.showCopyLink);
                }
              }
            });
          });
          
          // Start observing the trigger for attribute changes
          observer.observe(trigger, {
            attributes: true,
            attributeFilter: ['data-trigger']
          });
          
          // Also listen for trigger click events as backup
          trigger.addEventListener("click", () => {
            // Use a small delay to ensure the data-trigger attribute is updated
            setTimeout(() => {
              if (trigger.dataset.trigger === "on") {
                singleFaq.classList.add(self.CLASSES.showCopyLink);
              } else {
                singleFaq.classList.remove(self.CLASSES.showCopyLink);
              }
            }, 50);
          });
        }
      });
    }
  }

  render() {
    super.render();
    this.bindSearch();
    this.bindEvents();
    this.singleFaqOpen();
    this.singleFaqLinkCopy();
    this.bindFooterCardActive();
    this.bindCopyLinkVisibility();
  }
}
